import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMinusMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMinusMedium"><Path fillRule="evenodd" clipRule="evenodd" d="M4.5 11H19.5V13H4.5V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMinusMedium;
